import type { flightEntity } from 'freedom-shared';

export * from './mismatched-city';
export * from './baggages';

export type MappedFlight = flightEntity.types.MappedFlight;
export type ExpandedAirline = flightEntity.types.ExpandedAirline;
export type MappedOffer = flightEntity.types.MappedOffer;
export type MappedSegmentPoint = flightEntity.types.MappedSegmentPoint;
export type MappedSegment = flightEntity.types.MappedSegment;
